import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID
};

// Validate environment variables
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error('🔥 Firebase configuration error: Missing environment variables!');
}

const app = initializeApp(firebaseConfig);

// Initialize App Check
const initAppCheck = () => {
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isLocalNetwork = /^(192\.168\.|10\.|172\.(1[6-9]|2[0-9]|3[01])\.)/.test(window.location.hostname);

  // Skip AppCheck in development on local network (mobile testing)
  if (isDevelopment && (isLocalhost || isLocalNetwork)) {
    console.log('🔧 App Check skipped for local development');
    return null;
  }

  if (!recaptchaSiteKey) {
    console.warn('⚠️ reCAPTCHA site key missing - skipping App Check');
    return null;
  }

  try {
    // Only use debug token in development
    if (isDevelopment) {
      const debugToken = process.env.REACT_APP_RECAPTCHA_DEBUG_TOKEN;
      if (debugToken) {
        window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
        console.log('🔧 App Check debug mode enabled');
      }
    }

    const appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true
    });
    console.log('✅ App Check initialized successfully');
    return appCheck;
  } catch (error) {
    console.warn('⚠️ App Check initialization failed (non-critical):', error.message);
    return null;
  }
};

// Initialize App Check after a small delay to ensure reCAPTCHA script is loaded
// Only in production or when explicitly configured
if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
  setTimeout(initAppCheck, 2000);
} else {
  console.log('🔧 App Check disabled for development');
}

const auth = getAuth(app);
const db = getFirestore(app);

// Set persistence to LOCAL
setPersistence(auth, browserLocalPersistence);

// Export both app and db for flexibility
export { app, db, auth };
